import {form} from './form';
import {FormGroup} from '@angular/forms';

export class abstractForm implements form {

  getForm(model?: any): {} {
    return undefined;
  }

  getData(group): any {
    const data = {};
    for (const key in group.controls) {
      data[key] = group.controls[key].value;
    }
    return data;
  }

  updateForm(_form: FormGroup, obj?: any) {
    if (obj) {
      for (const key in obj) {
        const control: any = _form.controls[key];
        if (control && control.patchValue) {
          if (!(obj[key] instanceof Array)) {
            if (obj[key] || typeof obj[key] === 'boolean') {
              control.patchValue(obj[key]);
            }
          }
        }
      }
    } else {
      for (const key in _form.controls) {
        const control: any = _form.controls[key];
        if (control && control.patchValue) {
          if (!(obj[key] instanceof  Array)) {
            control.patchValue(null);
          }
        }
      }
    }
  }
}
